import { defaultThemeNewDesignColors } from './DefaultTheme';
import { defaultThemeFontsNewDesign } from './Fonts';

export const defaultTheme = {
  colors: defaultThemeNewDesignColors,
  fonts: defaultThemeFontsNewDesign,
};
